var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('fiat-trade',{attrs:{"wanted-assets":_vm.wantedAssets,"submitting":_vm.submitting},on:{"submit":_vm.handlePutOrder}}),_c('introduction')],1)}
var staticRenderFns = []

export { render, staticRenderFns }